import * as R from 'ramda'

/**
 * This removes empty and null values from query object
 */
export default R.pickBy(value => !R.isNil(value) && !R.isEmpty(value))
